import { Flow_0_0_2 } from '@flexus/core';

export const BUI_34: Flow_0_0_2 = {
	id: '34',
	name: 'work_complete_component',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to invoice Izinga'
		}
	},
	startNode: '',
	nodes: {}
};
